import { Reveal } from "./Reveal";

export const Fees = () => (
  <section id="fees" data-testid="fees-section" className="bg-white py-16 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <div data-testid="fees-divider" aria-hidden="true" className="flex items-center justify-center gap-6 mb-14 md:mb-20">
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
        <img src="/assets/nua-mark-transparent.png" alt="" className="h-9 w-auto opacity-90" />
        <span className="h-px w-16 md:w-28 bg-[#0A2333]/15" />
      </div>

      <Reveal>
        <h2 data-testid="fees-heading" className="font-serif text-3xl md:text-4xl tracking-tight text-[#111413] max-w-3xl">
          Advice built on value, not commission.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div data-testid="fees-panel" className="mt-12 md:mt-16 border border-black/10 bg-[#F9F8F4]">
          <div className="grid grid-cols-1 md:grid-cols-12">
            <div className="md:col-span-6 p-8 md:p-12 border-b md:border-b-0 md:border-r border-black/10 space-y-5">
              <p className="text-base leading-relaxed text-[#4A524D]">
                At NUA Private Wealth, we believe financial advice fees should be clear, fair and
                completely transparent from day one. Rather than charging a blanket fee or taking
                a percentage of your hard-earned assets, our advice is priced entirely on the
                unique complexity of your situation.
              </p>
              <p className="text-base leading-relaxed text-[#4A524D]">
                If your financial landscape is straightforward, your investment reflects that
                simplicity with a lower cost. If your position involves multiple entities,
                complex superannuation schemes, a myriad of financial strategies or intricate
                estate planning, the engagement is scoped to reflect the depth of work required.
              </p>
              <p className="font-serif italic text-xl text-[#0A2333] leading-snug pt-2">
                We only partner with you if we're confident we can enhance your financial
                wellbeing.
              </p>
            </div>

            <div className="md:col-span-6 p-8 md:p-12 flex flex-col justify-center">
              <p className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-[#0A2333]">
                <span className="h-px w-8 bg-[#0A2333]" aria-hidden="true" />
                Every engagement begins with total clarity
              </p>

              <div className="mt-8 space-y-7" data-testid="fees-clarity">
                <div className="flex gap-5" data-testid="fees-point-1">
                  <span className="font-serif italic text-2xl text-[#A78558] leading-none">01</span>
                  <p className="text-base leading-relaxed text-[#111413]">
                    <strong>No surprises.</strong> Free initial consultation. Upfront financial
                    strategy (SOA) fees start at{" "}
                    <span className="whitespace-nowrap font-medium text-[#0A2333]">$2,000</span> and
                    ongoing fees vary depending on circumstances and complexity but have an upper
                    limit. Please call, text or email for more details.
                  </p>
                </div>
                <div className="flex gap-5 border-t border-black/10 pt-7" data-testid="fees-point-2">
                  <span className="font-serif italic text-2xl text-[#A78558] leading-none">02</span>
                  <p className="text-base leading-relaxed text-[#111413]">
                    <strong>Agreed in advance.</strong> Every fee is fixed and provided in writing
                    before any work commences, so you always know your exact commitment.
                  </p>
                </div>
                <div className="flex gap-5 border-t border-black/10 pt-7" data-testid="fees-point-3">
                  <span className="font-serif italic text-2xl text-[#A78558] leading-none">03</span>
                  <p className="text-base leading-relaxed text-[#111413]">
                    <strong>Aligned interests.</strong> Because our fees never grow just because your
                    portfolio does, our sole focus stays where it belongs — delivering objective
                    advice that moves you closer to your goals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
